/* global __API_ROOT_URL__ */

import angular from 'angular';
import constants from '../../constants';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

let _$http;
let _upload;

class supportDataService {
  constructor(
    $http,
    Upload
  ) {
    _$http = $http;
    _upload = Upload;

    console.log('app.services.supportDataService created');

    return this;
  }

  // Tickets page
  getDisplayLists() {
    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/ticket/displayList`,
      method: 'GET',
    });
  }

  transferQualifiedAlert(qualifiedAlertId) {
    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/ticket/transfer/${qualifiedAlertId}`,
      method: 'PUT',
      data: {
        id: qualifiedAlertId,
      },
      responseType: 'json',
    });
  }

  printTicket(ticketId) {
    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/ticket/${ticketId}/print`,
      method: 'POST',
      data: {},
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'arraybuffer',
    });
  }

  getTicket(ticketId) {
    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/ticket/${ticketId}`,
      method: 'GET',
    });
  }

  searchTickets(
    type,
    ticketNumber,
    keyword,
    fromDate,
    toDate,
    contact,
    status,
    priority,
    sourceAccountManager,
    sourceCall,
    sourceClientPortal,
    sourceEmail,
    sourceFirewall,
    sourceInsourced,
    sourceLookout,
    sourceNetComply,
    sourceAdvancedEndPointSecurity,
    sourceCloudInsight,
    sortColumn,
    sortAscending
  ) {
    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/ticket`,
      method: 'GET',
      params: {
        type,
        number: ticketNumber,
        keyword,
        from: fromDate,
        to: toDate,
        contact,
        status,
        priority,
        sourceAccountManager,
        sourceCall,
        sourceClientPortal,
        sourceEmail,
        sourceFirewall,
        sourceInsourced,
        sourceLookout,
        sourceNetComply,
        sourceAdvancedEndPointSecurity,
        sourceCloudInsight,
        sortColumn,
        sortAscending
      },
    });
  }

  saveTicket(ticket) {
    if (ticket.id.length > 0) {
      return _$http({
        url: `${__API_ROOT_URL__}/salesForce/ticket/${ticket.id}`,
        method: 'PUT',
        data: ticket,
        responseType: 'json',
      });
    }

    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/ticket?echo=true`,
      method: 'POST',
      data: ticket,
      responseType: 'json',
    });
  }

  saveNote(note) {
    if (note.id) {
      return _$http({
        url: `${__API_ROOT_URL__}/salesForce/note/${note.id}`,
        method: 'PUT',
        data: note,
        responseType: 'json',
      });
    }

    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/note?echo=true`,
      method: 'POST',
      data: note,
      responseType: 'json',
    });
  }

  getContact(contactId) {
    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/contact/${contactId}`,
      method: 'GET',
    });
  }

  createTicketAttachment(file, id) {
    return _upload.upload({
      url: `${__API_ROOT_URL__}/salesForce/attachment/forTicket/${id}`,
      data: {
        file,
        echo: true
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getTicketAttachment(attachmentId) {
    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/attachment/${attachmentId}`,
      method: 'GET',
      // responseType: 'blob',
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}

supportDataService.$inject = [
  '$http',
  'Upload'
];

export default angular.module('app.services.supportDataService', [
  ngFileUpload,
  constants,
])
  .service('supportDataService', supportDataService)
  .name;
